/* __next_internal_client_entry_do_not_use__ BrandPageSearch auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import StringHighlight from "@faire/retailer-visitor-shared/components/TopSearch/ResultDropdown/StringHighlight/index";
import { stringOrUndefined } from "@faire/retailer-visitor-shared/lib/stringOrUndefined";
import { useSearchHandler } from "@faire/retailer-visitor-shared/views/brand/useSearchHandler";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Opacity } from "@faire/web--source/slate/Color";
import { Family } from "@faire/web--source/slate/Font";
import { Search } from "@faire/web--source/slate/icons/Search";
import { Column, Flex, Row } from "@faire/web--source/slate/Layout";
import { SearchInput } from "@faire/web--source/slate/SearchInput";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography, TypographyStyles } from "@faire/web--source/slate/Typography";
import ClickOutside from "@faire/web--source/ui/ClickOutside";
import { useDebouncedValue } from "@faire/web--source/ui/hooks/useDebouncedValue";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { useState } from "@faire/web--source/ui/hooks/useState";
import { useMutation as useSearchSuggestionMutation } from "@faire/web-api--source/api/v2/search/products/from-brand/suggestions/post-hooks";
import { trackSearchSuggestionClick } from "@faire/web-api--source/events/search/click/suggestion";
import { trackSearchSuggestionsView } from "@faire/web-api--source/events/search/view/suggestions";
import { IBrandPageSearchSuggestionsRequest } from "@faire/web-api--source/indigofair/data/IBrandPageSearchSuggestionsRequest";
import { QueryParameters as BrandPageQueryParams } from "@faire/web-api--source/routes/brand/brandToken";
import { observer } from "mobx-react";
import { useCallback, useEffect, useRef } from "react";
import * as React from "react";
import styled from "styled-components";
var BrandPageSearchBase = function(props) {
    var _searchSuggestions_suggestions;
    var search = useSearchHandler();
    var queryParams = useQueryParams(BrandPageQueryParams.parse);
    var _useState = _sliced_to_array(useState(false), 2), showSearchDropdown = _useState[0], setShowSearchDropdown = _useState[1];
    var _stringOrUndefined;
    var _useState1 = _sliced_to_array(useState((_stringOrUndefined = stringOrUndefined(queryParams.q)) !== null && _stringOrUndefined !== void 0 ? _stringOrUndefined : ""), 2), inputValue = _useState1[0], setInputValue = _useState1[1];
    var _useState2 = _sliced_to_array(useState(undefined), 2), searchSuggestions = _useState2[0], setSearchSuggestions = _useState2[1];
    var _useState3 = _sliced_to_array(useState(-1), 2), selected = _useState3[0], setSelected = _useState3[1];
    var currentIndex = useRef(-1);
    var searchQuery = useRef(inputValue);
    useEffect(function() {
        var _stringOrUndefined;
        searchQuery.current = (_stringOrUndefined = stringOrUndefined(queryParams.q)) !== null && _stringOrUndefined !== void 0 ? _stringOrUndefined : "";
        var _stringOrUndefined1;
        setInputValue((_stringOrUndefined1 = stringOrUndefined(queryParams.q)) !== null && _stringOrUndefined1 !== void 0 ? _stringOrUndefined1 : "");
    }, [
        queryParams.q
    ]);
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useState4 = _sliced_to_array(useState(undefined), 2), debouncedQuery = _useState4[0], setDebouncedQuery = _useState4[1];
    var debouncedSearchValue = useDebouncedValue(debouncedQuery, 300);
    var isFirstRender = useRef(true);
    var _searchSuggestions_suggestions_flatMap;
    var allSuggestions = (_searchSuggestions_suggestions_flatMap = searchSuggestions === null || searchSuggestions === void 0 ? void 0 : (_searchSuggestions_suggestions = searchSuggestions.suggestions) === null || _searchSuggestions_suggestions === void 0 ? void 0 : _searchSuggestions_suggestions.flatMap(function(suggestions) {
        return suggestions.suggested_queries;
    })) !== null && _searchSuggestions_suggestions_flatMap !== void 0 ? _searchSuggestions_suggestions_flatMap : [];
    var handleKeyDown = function(event) {
        var value = event.currentTarget.value;
        var RETURN_KEY = 13;
        var ESCAPE_KEY = 27;
        var ARROW_UP = 38;
        var ARROW_DOWN = 40;
        switch(event.keyCode || event.key){
            case RETURN_KEY:
            case "Enter":
                event.preventDefault();
                if (selected > -1) {
                    var _searchSuggestions_referrer_for_search, _searchSuggestions_referrer_for_search1;
                    var _allSuggestions_selected;
                    var query = (_allSuggestions_selected = allSuggestions[selected]) !== null && _allSuggestions_selected !== void 0 ? _allSuggestions_selected : "";
                    setInputValue(query);
                    var _searchSuggestions_referrer_for_search_referrer_request_id;
                    search(query, searchSuggestions === null || searchSuggestions === void 0 ? void 0 : (_searchSuggestions_referrer_for_search = searchSuggestions.referrer_for_search) === null || _searchSuggestions_referrer_for_search === void 0 ? void 0 : _searchSuggestions_referrer_for_search.referrer_type, (_searchSuggestions_referrer_for_search_referrer_request_id = searchSuggestions === null || searchSuggestions === void 0 ? void 0 : (_searchSuggestions_referrer_for_search1 = searchSuggestions.referrer_for_search) === null || _searchSuggestions_referrer_for_search1 === void 0 ? void 0 : _searchSuggestions_referrer_for_search1.referrer_request_id) !== null && _searchSuggestions_referrer_for_search_referrer_request_id !== void 0 ? _searchSuggestions_referrer_for_search_referrer_request_id : "");
                    setSelected(-1);
                } else {
                    search(value);
                }
                setShowSearchDropdown(false);
                if (props.onEnterKeyPressed) {
                    props.onEnterKeyPressed();
                }
                break;
            case ESCAPE_KEY:
            case "Escape":
                event.preventDefault();
                handleClear();
                break;
            case ARROW_UP:
                event.preventDefault();
                setSelected(selected > -1 ? selected - 1 : selected);
                break;
            case ARROW_DOWN:
                event.preventDefault();
                setSelected(selected < allSuggestions.length - 1 ? selected + 1 : selected);
                break;
            default:
                break;
        }
    };
    var _useSearchSuggestionMutation = useSearchSuggestionMutation({
        onSuccess: function(data) {
            setSearchSuggestions(data);
            setShowSearchDropdown(true);
            setDebouncedQuery(undefined);
        },
        onError: function() {
            setSearchSuggestions(undefined);
        }
    }), getSearchSuggestions = _useSearchSuggestionMutation.mutate;
    var handleClear = function() {
        setInputValue("");
        searchQuery.current = "";
        search("");
    };
    var onClickOutside = function() {
        setShowSearchDropdown(false);
    };
    var focusSearchBar = function() {
        fetchSearchSuggestions(searchQuery.current);
        setSelected(-1);
    };
    var fetchSearchSuggestions = useCallback(function(queryValue) {
        var _props_brandToken;
        getSearchSuggestions([
            IBrandPageSearchSuggestionsRequest.build({
                brand_token: (_props_brandToken = props.brandToken) !== null && _props_brandToken !== void 0 ? _props_brandToken : "",
                query: queryValue
            })
        ]);
    }, [
        props.brandToken,
        getSearchSuggestions
    ]);
    useEffect(function() {
        if (isFirstRender.current) {
            isFirstRender.current = false;
        } else {
            if (debouncedSearchValue !== undefined) {
                fetchSearchSuggestions(debouncedSearchValue);
            }
        }
    }, [
        debouncedSearchValue,
        fetchSearchSuggestions
    ]);
    var getDropdownSuggestions = function() {
        var _searchSuggestions_suggestions;
        return searchSuggestions === null || searchSuggestions === void 0 ? void 0 : (_searchSuggestions_suggestions = searchSuggestions.suggestions) === null || _searchSuggestions_suggestions === void 0 ? void 0 : _searchSuggestions_suggestions.map(function(suggestions, sectionIndex) {
            return /*#__PURE__*/ _jsx(SearchSuggestionSection, {
                suggestions: searchSuggestions,
                section: suggestions,
                sectionIndex: sectionIndex,
                query: searchQuery.current,
                currentIndex: currentIndex.current,
                selected: selected,
                setSelected: setSelected,
                onClick: function(suggested_query, index) {
                    var _searchSuggestions_referrer_for_search, _searchSuggestions_referrer_for_search1, _searchSuggestions_referrer_for_search2, _searchSuggestions_referrer_for_search3, _props_onEnterKeyPressed;
                    var _searchSuggestions_referrer_for_search_referrer_request_id;
                    trackSearchSuggestionClick("".concat((_searchSuggestions_referrer_for_search = searchSuggestions.referrer_for_search) === null || _searchSuggestions_referrer_for_search === void 0 ? void 0 : _searchSuggestions_referrer_for_search.referrer_type, "|").concat(sectionIndex), (_searchSuggestions_referrer_for_search_referrer_request_id = (_searchSuggestions_referrer_for_search1 = searchSuggestions.referrer_for_search) === null || _searchSuggestions_referrer_for_search1 === void 0 ? void 0 : _searchSuggestions_referrer_for_search1.referrer_request_id) !== null && _searchSuggestions_referrer_for_search_referrer_request_id !== void 0 ? _searchSuggestions_referrer_for_search_referrer_request_id : "", "".concat(inputValue, "|").concat(suggested_query, "|").concat(index));
                    setInputValue(suggested_query);
                    searchQuery.current = suggested_query;
                    var _searchSuggestions_referrer_for_search_referrer_request_id1;
                    search(suggested_query, (_searchSuggestions_referrer_for_search2 = searchSuggestions.referrer_for_search) === null || _searchSuggestions_referrer_for_search2 === void 0 ? void 0 : _searchSuggestions_referrer_for_search2.referrer_type, (_searchSuggestions_referrer_for_search_referrer_request_id1 = (_searchSuggestions_referrer_for_search3 = searchSuggestions.referrer_for_search) === null || _searchSuggestions_referrer_for_search3 === void 0 ? void 0 : _searchSuggestions_referrer_for_search3.referrer_request_id) !== null && _searchSuggestions_referrer_for_search_referrer_request_id1 !== void 0 ? _searchSuggestions_referrer_for_search_referrer_request_id1 : "");
                    setShowSearchDropdown(false);
                    (_props_onEnterKeyPressed = props.onEnterKeyPressed) === null || _props_onEnterKeyPressed === void 0 ? void 0 : _props_onEnterKeyPressed.call(props);
                }
            }, sectionIndex);
        });
    };
    var _props_placeholder;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(SearchWrapper, {
            onClickOutside: onClickOutside,
            children: [
                /*#__PURE__*/ _jsx(FullWidthSearchField, {
                    id: "brand-search",
                    value: inputValue,
                    onClear: handleClear,
                    onFocus: focusSearchBar,
                    onChange: function(e) {
                        var value = e.currentTarget.value;
                        setInputValue(value);
                        searchQuery.current = value;
                        setDebouncedQuery(value);
                    },
                    onKeyDown: handleKeyDown,
                    placeholder: showSearchDropdown ? "" : (_props_placeholder = props.placeholder) !== null && _props_placeholder !== void 0 ? _props_placeholder : strictLocalize({
                        id: "vk0dnR",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Search all products"
                            }
                        ]
                    }),
                    "data-test-id": props["data-test-id"],
                    autoFocus: props.autoFocus,
                    className: props.className
                }),
                showSearchDropdown ? getDropdownSuggestions() : null
            ]
        })
    });
};
var SearchSuggestionSection = function(param) {
    var suggestions = param.suggestions, section = param.section, sectionIndex = param.sectionIndex, onClick = param.onClick, query = param.query, selected = param.selected, setSelected = param.setSelected, currentIndex = param.currentIndex;
    var ref = useDoActionWhenVisible(function() {
        var _suggestions_referrer_for_search, _suggestions_referrer_for_search1;
        var _suggestions_referrer_for_search_referrer_request_id;
        trackSearchSuggestionsView("".concat(suggestions === null || suggestions === void 0 ? void 0 : (_suggestions_referrer_for_search = suggestions.referrer_for_search) === null || _suggestions_referrer_for_search === void 0 ? void 0 : _suggestions_referrer_for_search.referrer_type, "|").concat(sectionIndex), (_suggestions_referrer_for_search_referrer_request_id = suggestions === null || suggestions === void 0 ? void 0 : (_suggestions_referrer_for_search1 = suggestions.referrer_for_search) === null || _suggestions_referrer_for_search1 === void 0 ? void 0 : _suggestions_referrer_for_search1.referrer_request_id) !== null && _suggestions_referrer_for_search_referrer_request_id !== void 0 ? _suggestions_referrer_for_search_referrer_request_id : "", "".concat(query, "|").concat(section.suggested_queries.join("|")));
    });
    return /*#__PURE__*/ _jsxs(ResultDropdown, {
        gap: "1x",
        ref: ref,
        children: [
            section.suggestion_header ? /*#__PURE__*/ _jsxs(ItemWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraphSansMedium",
                        children: section.suggestion_header
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    })
                ]
            }) : null,
            section.suggested_queries.map(function(suggested_query, index) {
                currentIndex++;
                return /*#__PURE__*/ _jsx(DropdownItem, {
                    label: suggested_query,
                    index: currentIndex,
                    selectedIndex: selected,
                    onHover: setSelected,
                    onClick: function() {
                        return onClick(suggested_query, index);
                    },
                    query: query
                }, suggested_query);
            })
        ]
    });
};
var DropdownItem = function(param) {
    var label = param.label, index = param.index, selectedIndex = param.selectedIndex, onHover = param.onHover, onClick = param.onClick, query = param.query;
    return /*#__PURE__*/ _jsxs(ItemWrapper, {
        gap: "2x",
        align: "center",
        $selected: selectedIndex === index,
        onMouseEnter: function() {
            return onHover === null || onHover === void 0 ? void 0 : onHover(index);
        },
        onClick: function(e) {
            e.preventDefault();
            onClick === null || onClick === void 0 ? void 0 : onClick();
        },
        children: [
            /*#__PURE__*/ _jsx(IconWrapper, {
                children: /*#__PURE__*/ _jsx(Search, {
                    height: "16px",
                    width: "16px",
                    color: Core.text.default,
                    strokeWidth: 1
                })
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(StringHighlight, {
                    message: label,
                    highlight: query,
                    reverseHighlight: true
                })
            })
        ]
    });
};
export var BrandPageSearch = observer(BrandPageSearchBase);
var FullWidthSearchField = styled(SearchInput).withConfig({
    componentId: "sc-6cbbced2-0"
})([
    "width:100%;"
]);
var ResultDropdown = styled(Column).withConfig({
    componentId: "sc-6cbbced2-1"
})([
    "width:100%;background:",
    ";padding:",
    ";z-index:12;",
    "{position:fixed;top:70px;left:0px;}",
    "{position:absolute;top:50px;}",
    "{box-shadow:0 7px 10px ",
    ";}overflow-y:auto;"
], Core.surface.inverse, getSpacing("2x", 0, "2x", 0), responsiveMediaQueries.mobile, responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.desktopAndAbove, Core.surface.enabled + Opacity.O_10);
var IconWrapper = styled(Flex).attrs({
    justify: "center",
    align: "center"
}).withConfig({
    componentId: "sc-6cbbced2-2"
})([
    "height:40px;width:40px;border-radius:50%;background-color:",
    ";"
], Core.surface.subdued);
var ItemWrapper = styled(Row).withConfig({
    componentId: "sc-6cbbced2-3"
})([
    "background-color:",
    ";padding:",
    ";strong{",
    "}"
], function(param) {
    var $selected = param.$selected;
    return $selected ? Core.surface.subdued + Opacity.O_50 : undefined;
}, getSpacing(4, "2x", 4, "2x"), TypographyStyles({
    truncate: true,
    variant: "paragraphSansMedium"
}));
var SearchWrapper = styled(ClickOutside).withConfig({
    componentId: "sc-6cbbced2-4"
})([
    "font-family:",
    ";display:flex;flex-direction:row;align-items:center;position:relative;border-radius:50%;z-index:11;",
    "{width:100%;}",
    "{flex-grow:1;}background:white;"
], Family.sansSerif, responsiveMediaQueries.mobile, responsiveMediaQueries.tabletAndAbove);
